module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<select name=\"category\">\n<%\nvar catID, catTitle;\nvar cats = model.projectImmoCategories || {};\nif(Object.keys(cats).length > 1){\n%><option value=\"all\">Alle</option><%\n}\nfor(catID in model.projectImmoCategories || {}){\ncatTitle = model.projectImmoCategories[catID];\n%>\n<option value=\"<%= catID %>\"><%= catTitle %></option>\n<%\n}\n%>\n</select>\n</div>"
  , __filename = "components/templates/project/objectList/categoryFilter.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<select name=\"category\">\n")
    ; __line = 3
    ; 
var catID, catTitle;
var cats = model.projectImmoCategories || {};
if(Object.keys(cats).length > 1){

    ; __line = 7
    ; __append("<option value=\"all\">Alle</option>")
    ; 
}
for(catID in model.projectImmoCategories || {}){
catTitle = model.projectImmoCategories[catID];

    ; __line = 11
    ; __append("\n<option value=\"")
    ; __line = 12
    ; __append(escapeFn( catID ))
    ; __append("\">")
    ; __append(escapeFn( catTitle ))
    ; __append("</option>\n")
    ; __line = 13
    ; 
}

    ; __line = 15
    ; __append("\n</select>\n</div>")
    ; __line = 17
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/objectList/categoryFilter.ejs

}